import {
  MnemonicLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { GraphemeMnemonicsPronunciationScreenSuspense } from "#grapheme-mnemonics-pronunciation-screen-suspense";

export function GraphemeMnemonicsPronunciationScreen({
  rawPinyin,
}: {
  rawGrapheme: string | string[];
  rawPinyin: string | string[];
}) {
  const selectedPinyin = rawPinyin.toString();

  return (
    <SuspensePageBoundary fallback={<MnemonicLayoutSkeleton />} location={import.meta.location}>
      <GraphemeMnemonicsPronunciationScreenSuspense selectedPinyin={selectedPinyin} />
    </SuspensePageBoundary>
  );
}
